import { Button } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";

interface CancelSubscriptionCardProps {
  onCancel: () => void;
}

export const CancelSubscriptionCard = ({
  onCancel,
}: CancelSubscriptionCardProps) => {
  const { t } = useTranslations();

  return (
    <div className="flex min-h-[144px] w-full max-w-[1000px] items-center justify-between rounded-[18px] border border-solid border-dark-100 bg-white px-8 py-6">
      <div className="flex flex-col gap-1">
        <span className="font-secondary text-xl leading-[33px] font-semibold text-dark">
          {t({
            id: "cx-plans-page.cancel-subscription-card.title",
            defaultMessage: "Cancel Subscription",
          })}
        </span>
        <span className="max-w-[520px] font-secondary text-sm leading-[21px] text-dark-700">
          {t({
            id: "cx-plans-page.cancel-subscription-card.description-canceled",
            defaultMessage:
              "By Canceling Plan - you will loose access to Plan features & Add-ons",
          })}
        </span>
      </div>

      <Button variant="tertiary" onClick={onCancel}>
        {t({
          id: "cx-plans-page.cancel-subscription-card.cancel-button",
          defaultMessage: "Cancel Subscription",
        })}
      </Button>
    </div>
  );
};
